import { Text, Container, FlexRow, getContentHorizontalPadding, Icon } from "@utdanningsdirektoratet/lisa";
import { colors, contentMaxWidth, padding, spacing } from "@utdanningsdirektoratet/lisa-tokens";
import React from "react";
import { styled } from "styled-components";

interface Props {
	systemmelding: string;
}
export const SystemmeldingSingle: React.FC<Props> = ({ systemmelding }) => {
	if (!systemmelding) return null;
	return (
		<Background role="alert">
			<SystemmeldingContainer>
				<Icon type={"warning"} iconColor="svart" />
				<Container>
					<Text>
						<Text textStyle="bodyBold" as="span">
							Systemmelding:{" "}
						</Text>
						{systemmelding}
					</Text>
				</Container>
			</SystemmeldingContainer>
		</Background>
	);
};

const Background = styled.div`
	${padding(16)}
	z-index: 4;
	position: relative;
	background-color: ${colors.oransje400};
`;
const SystemmeldingContainer = styled(FlexRow)`
	${getContentHorizontalPadding(false)}
	max-width: ${contentMaxWidth}px;
	gap: ${spacing(4)};
`;
